import React from 'react';
import type { CheckboxProps } from '@components/moleculs/checkbox/types';
import cn from 'classnames';
import { styled } from 'styled-components';

import { Cb, FormControlLabelStyled } from './styles';

const Molecule: React.FC<CheckboxProps> = ({
    fieldState,
    label,
    className,
    error,
    ...rest
}) => (
    <FormControlLabelStyled
        className={cn('MuiCheckbox-root', className)}
        label={label}
        control={<Cb {...rest} $error={error} />}
        labelPlacement='end'
    />
);

export const Checkbox = styled(Molecule)({});
